import { ItemCategoryFilter } from "../filter/ItemCategoryFilter";
import { ItemNameSearch } from "../search/ItemNameSearch";
import { Body14Medium } from "../typography/Body14Medium";

interface Props {
  totalElements: number;
  searchItemName: string;
  handleSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleCategoryChange: (categoryIds: number[]) => void;
}

export const ItemMainBar: React.FC<Props> = ({
  totalElements,
  searchItemName,
  handleSearchChange,
  handleCategoryChange,
}) => {
  return (
    <div className="flex items-center justify-between mb-[8px]">
      <Body14Medium className="text-semantic-text-body">
        {totalElements}개의 상품
      </Body14Medium>
      <div className="flex gap-[16px]">
        <ItemNameSearch
          searchItemName={searchItemName}
          handleSearchChange={handleSearchChange}
        />
        <ItemCategoryFilter handleCategoryChange={handleCategoryChange} />
      </div>
    </div>
  );
};
